import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ErrorAlert from '../ErrorAlert'
import { t } from '../../utils/i18n'
import CountryOptions from '../CountryOptions'
import Popover from '../Popover'
import {
  getQuoteSetQuantity,
  getQuoteSetCompanyName,
  getQuoteSetCompanyAddressLine1,
  getQuoteSetCompanyAddressLine2,
  getQuoteSetCompanyCountry,
  getQuoteSetCompanyVatNo,
  getQuoteSetCompanyEmail,
  getQuoteSetCompanyTelephone,
  getQuoteSetContactPerson,
  getQuoteSetComments,
  getQuoteSubmit
} from '../../actions'

const GetQuotePopover: React.FC = () => {
  const dispatch = useDispatch()
  const {
    done,
    errors,
    submitting,
    quantity,
    companyName,
    companyAddressLine1,
    companyAddressLine2,
    companyCountry,
    companyVatNo,
    companyEmail,
    companyTelephone,
    contactPerson,
    comments
  } = useSelector((state: any) => state.getQuote)

  return (
    <Popover
      minWidth={'250px'}
      width={'90%'}
      maxWidth={'500px'}
      alignTo={
        window.innerWidth > 768
          ? '.velorbis-customizer-header-inquiry'
          : '.velorbis-customizer-header-settings'
      }
      position="below"
    >
      <div className="velorbis-customizer-popover-header">
        {t('get_quote_title')}
      </div>
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-scroll">
        {done ? (
          <div>{t('email_sent')}</div>
        ) : (
          <div className="velorbis-customizer-space-dist-v">
            <ErrorAlert errors={errors} />
            <div className="velorbis-customizer-form-control">
              <label>{t('quantity')}</label>
              <input
                type="number"
                className="velorbis-customizer-input"
                value={quantity}
                onChange={(e) => dispatch(getQuoteSetQuantity(e.target.value))}
              />
            </div>
            <div className="velorbis-customizer-form-control">
              <label>{t('company_name')}</label>
              <input
                type="text"
                className="velorbis-customizer-input"
                value={companyName}
                onChange={(e) =>
                  dispatch(getQuoteSetCompanyName(e.target.value))
                }
              />
            </div>
            <div className="velorbis-customizer-form-control">
              <label>{t('company_address_line1')}</label>
              <input
                type="text"
                className="velorbis-customizer-input"
                value={companyAddressLine1}
                onChange={(e) =>
                  dispatch(getQuoteSetCompanyAddressLine1(e.target.value))
                }
              />
            </div>
            <div className="velorbis-customizer-form-control">
              <label>{t('company_address_line2')}</label>
              <input
                type="text"
                className="velorbis-customizer-input"
                value={companyAddressLine2}
                onChange={(e) =>
                  dispatch(getQuoteSetCompanyAddressLine2(e.target.value))
                }
              />
            </div>
            <div className="velorbis-customizer-form-control">
              <label>{t('company_country')}</label>
              <select
                className="velorbis-customizer-input"
                value={companyCountry || ''}
                onChange={(e) =>
                  dispatch(getQuoteSetCompanyCountry(e.target.value))
                }
              >
                <option disabled hidden value="">
                  &#160;
                </option>
                <CountryOptions />
              </select>
            </div>
            <div className="velorbis-customizer-form-control">
              <label>{t('company_vat_no')}</label>
              <input
                type="text"
                className="velorbis-customizer-input"
                value={companyVatNo}
                onChange={(e) =>
                  dispatch(getQuoteSetCompanyVatNo(e.target.value))
                }
              />
            </div>
            <div className="velorbis-customizer-form-control">
              <label>{t('company_email')}</label>
              <input
                type="email"
                className="velorbis-customizer-input"
                value={companyEmail}
                onChange={(e) =>
                  dispatch(getQuoteSetCompanyEmail(e.target.value))
                }
              />
            </div>
            <div className="velorbis-customizer-form-control">
              <label>{t('company_telephone')}</label>
              <input
                type="text"
                className="velorbis-customizer-input"
                value={companyTelephone}
                onChange={(e) =>
                  dispatch(getQuoteSetCompanyTelephone(e.target.value))
                }
              />
            </div>
            <div className="velorbis-customizer-form-control">
              <label>{t('contact_person')}</label>
              <input
                type="text"
                className="velorbis-customizer-input"
                value={contactPerson}
                onChange={(e) =>
                  dispatch(getQuoteSetContactPerson(e.target.value))
                }
              />
            </div>
            <div className="velorbis-customizer-form-control">
              <label>{t('comments')}</label>
              <textarea
                className="velorbis-customizer-input"
                value={comments}
                onChange={(e) => dispatch(getQuoteSetComments(e.target.value))}
                rows={6}
              />
            </div>
            <div className="velorbis-customizer-popover-buttons">
              <button
                className="velorbis-customizer-button"
                onClick={() => dispatch(getQuoteSubmit())}
                disabled={submitting}
              >
                {t('send_button')}
              </button>
            </div>
          </div>
        )}
      </div>
    </Popover>
  )
}

export default GetQuotePopover
